import { Directive, ElementRef, Input, OnInit } from '@angular/core'
import Inputmask from 'inputmask'

@Directive({
  selector: '[appInputMask]',
  standalone: false
})
export class InputMaskDirective implements OnInit {
  @Input() appInputMask: Inputmask.Options
  constructor(private el: ElementRef) {}
  ngOnInit() {
    const input = this.el.nativeElement as HTMLInputElement
    input.setAttribute('autocomplete', 'off')
    Inputmask(this.appInputMask).mask(input)
  }
}
